import { Tooltip } from '@lib/components'
import type React from 'react'

import { TABLET_LANDSCAPE_MEDIA } from '@/constants/media'
import useMediaQuery from '../../../../../../../lib/hooks/useMediaQuery'
import { SettingsButton, SettingsDropdown } from './components'
import css from './styles.module.css'
import { useSettings } from './useSettings'

export const Settings: React.FC = () => {
  const { canEdit, active, onClick } = useSettings()
  const tabletLandscape = useMediaQuery(TABLET_LANDSCAPE_MEDIA)

  if (!canEdit) {
    return null
  }

  if (!tabletLandscape) {
    return <SettingsDropdown />
  }

  return (
    <Tooltip
      content="Project settings"
      wrap={false}
      tooltipClassName={css.tooltip}
    >
      <SettingsButton active={active} onClick={onClick} />
    </Tooltip>
  )
}
